import { TIcon } from '@acceso/design-system';

import { TableRow } from '../TableRow/TableRow';

type TableRowInfoProps = {
  title?: string;
  description?: string | null;
  icon?: TIcon;

  /**
   * @default false
   */
  showTooltip?: boolean;
};

export function TableRowInfo({
  icon: Icon,
  description,
  title,
  showTooltip = false,
}: TableRowInfoProps) {
  return (
    <div className="flex gap-2">
      {Icon && <Icon className="text-accent-active-primary-30" />}

      <div>
        <TableRow showTooltip={showTooltip} content={title} className="font-semibold" />
        <TableRow content={description ?? ''} className="pt-1 text-text-medium-10" />
      </div>
    </div>
  );
}
